import { isSameWalletName } from '../isSameWalletName/isSameWalletName.js';

const shouldManuallyReconnectOnRefresh = (connector) => isSameWalletName(connector.name, 'phantom') ||
    isSameWalletName(connector.name, 'phantomledger') ||
    isSameWalletName(connector.name, 'glow') ||
    connector.connectedChain === 'STARK' ||
    connector.connectedChain === 'FLOW';

export { shouldManuallyReconnectOnRefresh };
